// XSS invariant: diff lines are attacker-controlled content and render ONLY as plain JSX text
// children (React auto-escapes) — never as HTML.
export function DiffText({ text }) {
  return (
    <pre className="rb-mono mt-2 overflow-x-auto rounded-xl border border-[color:var(--rb-border)] bg-[color:var(--rb-code)] p-3 text-xs leading-relaxed">
      {text.split("\n").map((l, i) => (
        <div key={i} className={
          l.startsWith("+++") || l.startsWith("---") ? "text-[color:var(--rb-text-faint)]"
            : l.startsWith("@@") ? "text-[color:var(--rb-accent)]"
            : l.startsWith("+") ? "text-[color:#4ade80]"
            : l.startsWith("-") ? "text-[color:#f87171]"
            : "text-[color:var(--rb-text-dim)]"
        }>{l || " "}</div>
      ))}
    </pre>
  );
}
